var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagUsa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 9,
    viewBox: "0 0 18 9",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h18v9h-18z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ff7b7b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9 0h9v1h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 2h9v1h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 4h9v1h-9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h9v5h-9z",
    fill: "#008eff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 6h18v1h-18z",
    fill: "#ff7b7b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 8h18v1h-18z",
    fill: "#ff7b7b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUsa);
export default __webpack_public_path__ + "static/media/flag-usa.01588a43a958f04c1235100e7c201506.svg";
export { ForwardRef as ReactComponent };